import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';

interface ResourceTypeListItemComponentArgs {
  resourceTypeId: number;
  label: string;
  count: number;
  icon: string;
  beta?: boolean;
}

export default class ResourceTypeListItemComponent extends Component<ResourceTypeListItemComponentArgs> {
  @service declare router: RouterService;

  @action
  navigateToResourcePage(): void {
    // Get the current query parameters
    const currentQueryParams = this.router.currentRoute?.queryParams || {};

    // Build the query string
    const queryString = Object.keys(currentQueryParams)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(currentQueryParams[key] ?? '')}`)
      .join('&');

    // Construct the full URL with query parameters
    const targetUrl = queryString
      ? `/resources/${this.args.resourceTypeId}?${queryString}`
      : `/resources/${this.args.resourceTypeId}`;

    // Navigate to the URL
    // note: tried passing into the queryParams into the transitionTo hook but that wasn't preserving the query params
    void this.router.transitionTo(targetUrl);
  }

  stopPropagation(e: Event): void {
    e.preventDefault();
    e.stopPropagation();
  }
}
